import common from '@/store/common/mutations';
import * as types from './mutation-types';

const getInit = () => {
	return {
		searchParams: {
			pgmId: null,
			jobGroupId: null,
			jobId: null,
			jobNm: null,
			useYn: null			
		},
		batchStatusList: [],
		useYnList: [],
		gridUseYnList: [],
		excelDownLoadList: [], //엑셀다운로드시 해더저장
		pagingInfo: {
			currentPage: 1,
			endPage: 1,
			pageUnit: 10,
			startPage: 1,
			totalSize: 1
		}
	};
};

export default {
	...common,	
	[types.STATE_INIT]: state => {
		Object.assign(state, getInit()); //
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	}
};
